export default {
  login: '/sso/userlogin',
  refreshToken: '/sso/refreshtoken',
  code: '/sso/logincode/prepare',
  logout: '/sso/userlogout',
  checktoken: '/sso/checktoken',
  checkURL: '/sso/checkURL',
  loadRes: '/sso/sysres',
  loadSystems: '/sso/usersystems',
  modifyPwd: '/sso/modifypwd',
  getQrCode: '/sso/getqrcode',
  getQrCodeStatus: '/sso/queryqrcodestatus',
  loadCitylist:'/sso/sysuser/citylist'
};



// WEBPACK FOOTER //
// ./src/api/auth.js